/**
 * 北京科锐配电自动化股份有限公司-数据
 */
// 北京科锐配电自动化股份有限公司
const kr_banner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner1.jpg";
const kr_banner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner2.jpg";
const kr_banner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner3.jpg";
const kr_banner4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner4.png";
const kr_banner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner5.png";
const kr_banner6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner6.png";
const kr_banner7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/kr_banner7.png";

const krQ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ1.png";
const krQ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ2.png";
const krQ3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ3.png";
const krQ4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ4.png";
const krQ5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ5.png";
const krQ6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ6.png";
const krQ7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ7.png";
const krQ8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ8.png";
const krQ9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krQ9.png";

const krC1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krC1.png";
const krC2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krC2.png";
const krC3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krC3.png";
const krC4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krC4.png";
const krC5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krC5.png";
const krImg = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krImg.png";

const krcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp1.png";
const krcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp2.png";
const krcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp3.png";
const krcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp4.png";
const krcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp5.png";
const krcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp6.png";
const krcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp7.png";
const krcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp8.png";
const krcp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp9.png";
const krcp10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp10.png";
const krcp11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp11.png";
const krcp12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp12.png";
const krcp13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp13.png";
const krcp14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp14.png";
const krcp15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp15.png";
const krcp16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp16.png";
const krcp17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krcp17.png";
//工程案例
const krlb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb1.png";
const krlb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb2.png";
const krlb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb3.png";
const krlb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb4.png";
const krlb5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb5.png";
const krlb6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb6.png";
const krlb7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb7.png";
const krlb8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb8.png";
const krlb9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb9.png";
const krlb10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb10.png";
const krlb11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb11.png";
const krlb12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krlb12.png";

const krht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht1.png";
const krht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht2.png";
const krht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht3.png";
const krht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht4.png";
const krht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht5.png";
const krht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht6.png";
const krht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht7.png";
const krht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht8.png";
const krht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht9.png";
const krht10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht10.png";
const krht11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht11.png";
const krht12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht12.png";
const krht13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht13.png";
const krht14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht14.png";
const krht15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht15.png";
const krht16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht16.png";
const krht17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht17.png";
const krht18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht18.png";
const krht19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht19.png";
const krht20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht20.png";
const krht21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krht12.png";
//详情页
const krxq1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq1.png";
const krxq2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq2.png";
const krxq3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq3.png";
const krxq4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq4.png";
const krxq5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq5.png";
const krxq6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq6.png";
const krxq7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq7.png";
const krxq8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq8.png";
const krxq9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq9.png";
const krxq10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq10.png";
const krxq11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq11.png";
const krxq12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq12.png";
const krxq13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq13.png";
const krxq14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq14.png";
const krxq15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq15.png";
const krxq16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq16.png";
const krxq17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krxq17.png";

const krbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg1.png";
const krbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg2.png";
const krbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg3.png";
const krbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg4.png";
const krbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg5.png";
const krbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg6.png";
const krbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg7.png";
const krbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg8.png";
const krbg9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg9.png";
const krbg10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg10.png";
const krbg11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg11.png";
const krbg12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg12.png";
const krbg13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg13.png";
const krbg14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg14.png";
const krbg15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg15.png";
const krbg16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg16.png";
const krbg17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg17.png";
const krbg18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg18.png";
const krbg19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg19.png";
const krbg20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg20.png";
const krbg21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg21.png";
const krbg22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg22.png";
const krbg23 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg23.png";
const krbg24 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg24.png";
const krbg25 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg25.png";
const krbg26 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg26.png";
const krbg27 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg27.png";
const krbg28 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg28.png";
const krbg29 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg29.png";
const krbg30 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg30.png";
const krbg31 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg31.png";
const krbg32 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg32.png";
const krbg33 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg33.png";
const krbg34 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg34.png";
const krbg35 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg35.png";
const krbg36 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg36.png";
const krbg37 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg37.png";
const krbg38 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg38.png";
const krbg39 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg39.png";
const krbg40 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg40.png";
const krbg41 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg41.png";
const krbg42 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg42.png";
const krbg43 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg43.png";
const krbg44 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg44.png";
const krbg45 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg45.png";
const krbg46 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg46.png";
const krbg47 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg47.png";
const krbg48 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg48.png";
const krbg49 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg49.png";
const krbg50 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg50.png";
const krbg51 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg51.png";
const krbg52 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg52.png";
const krbg53 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg53.png";
const krbg54 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg54.png";
const krbg55 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg55.png";
const krbg56 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg56.png";
const krbg57 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg57.png";
const krbg58 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg58.png";
const krbg59 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg59.png";
const krbg60 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg60.png";
const krbg61 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg61.png";
const krbg62 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg62.png";
const krbg63 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg63.png";
const krbg64 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg64.png";
const krbg65 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg65.png";
const krbg66 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg66.png";
const krbg67 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/kerui/krbg67.png";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
    homeData: {
		herderBanner: [kr_banner1, kr_banner2, kr_banner3, kr_banner4, kr_banner5, kr_banner6, kr_banner7],
		//企业logo
		logo: "https://www.creat-da.com.cn/Img/source/2017/05/11/201705111455473773.jpg",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: krImg,
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: true,
		videoLogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/krfm.jpg",
		videoUrl: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/mp4/kr.mp4",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `北京科锐配电自动化股份有限公司1988年创建于中国电力科学研究院，从事配电设备研发与制造、电力物业服务、分布式光伏、能源综合利用及配售电业务。公司自成立起即从事配电及控制设备的开发与生产，是国内最早从事配电自动化设备开发与生产的企业之一，在行业内处于领先地位。2010年成为上市公司，股票代码002350；
            北京科锐总部位于北京中关村核心地带——中关村软件园拥有25000平方米的总部大楼和研发场所，还在北京怀柔、郑州、武汉拥有占地300余亩的生产基地，并在雄安等全国各地设立多家分子公司。
            北京科锐多年来致力于配电系统的技术进步，崇尚技术创新，曾率先推出多种新型配电设备和工程技术方案，并在多年技术研发的基础上，形成了中低压开关设备、节能配电变压器、配电自动化、电缆附件、无功补偿、充电装置、光伏发电等系列产品，应用遍及全国各省区的配电网，及轨道交通、冶金、石化等领域和风电、光伏等新能源建设工程。
            2009年北京科锐技术研发中心被认定为“北京市级企业技术中心”，公司承担的863课题《基于网络式保护的配电网自愈控制技术》技术达到国际领先水平；非晶带材在电力系统中的应用开发及工程化项目获得国家科技进步奖和北京市科学技术奖，公司及子公司累计获得专利授权148项，其中发明专利42项；实用新型103项，外观设计专利3项。`,
		//公司官网
		website: "http://www.creat-da.com.cn/",
		operatingStatus: "正常在业",
		//经营品类
		categories: "变压器、高低压开关柜、环网柜、箱式变电站、柱上断路器",
		//公司地址
		companyAddress: "北京市海淀区西北旺东路10号院东区4号楼107",
		site: "北京市海淀区",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "54236.9011万人民币",
		//成立日期
		establishment: "1993-7-17",
		//经营品牌
		brand: "北京科锐；杭州平旦",
		//主营产品
		mainProducts: "变压器、高低压开关柜、环网柜、箱式变电站、柱上断路器",
		//企业名称
		headerTitle: "北京科锐配电自动化股份有限公司",
		moreInfoName: "北京科锐配电自动化股份有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.现款现结
        2.预付款（可与其他项组合）
        6.预留质保金（可与其他项组合）`,
		//工厂地址
		factoryAddress: "北京市海淀区西北旺东路10号院东区4号楼107",
		//工厂人数
		factoryHeadcount: "1629",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "300余亩",
		factoryHeadcount: "区域3-5个",
		capacity: "50亿元",

		//联系负责人
		person: "李欣 ",
		//联系电话
		contactNumber: "13810063422",
		//资质证书
		qualificationList: [
			{
				name: "9000认证证书环境配电",
				path: krQ1,
			},
			{
				name: "北京市新技术新产品（服务）证书 变电站预制仓",
				path: krQ2,
			},
			{
				name: "北京市新技术新产品（服务）证书 测控一体化终端",
				path: krQ3,
			},
			{
				name: "北京市新技术新产品（服务）证书 低温环网柜",
				path: krQ4,
			},
			{
				name: "北京市新技术新产品（服务）证书 故障定位系统",
				path: krQ5,
			},
			{
				name: "北京市新技术新产品（服务）证书 配电变压器",
				path: krQ6,
			},
			{
				name: "北京市新技术新产品（服务）证书 智能环网柜",
				path: krQ7,
			},
			{
				name: "职业健康安全管理体系认证证书",
				path: krQ8,
			},
			{
				name: "质量管理体系认证证书",
				path: krQ9,
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "北京市著名商标认定证书",
				path: krC1,
			},
			{
				name: "高新技术企业证书",
				path: krC2,
			},
			{
				name: "国家火炬计划重点高新技术企业",
				path: krC3,
			},
			{
				name: "市级企业技术中心证书",
				path: krC4,
			},
			{
				name: "中关村信用双百企业证书",
				path: krC5,
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "万科企业股份有限公司",
				path: "https://zhengxin-pub.cdn.bcebos.com/logopic/4cc4c71686ce803144c94bb850405de4_fullsize.jpg?x-bce-process=image/resize,m_lfit,w_200",
				desc: "万科企业股份有限公司成立于1984年，经过三十余年的发展，已成为国内领先的城乡建设与生活服务商，公司业务聚焦全国经济最具活力的三大经济圈及中西部重点城市。",
			},
			{
				name: "中国节能环保集团有限公司",
				path: "https://zhengxin-pub.cdn.bcebos.com/logopic/5ac0918f599c9e11d72cf4fd93aa95be_fullsize.jpg?x-bce-process=image/resize,m_lfit,w_200",
				desc: "中国节能环保集团有限公司，前身是中国节能投资公司，现为唯一一家主业为节能减排、环境保护的中央企业，是中国节能环保领域最大的科技型服务型产业集团。2010年3月，经国务院批准，中国节能投资公司与中国新时代控股（集团）公司实施联合重组，公司更名为中国节能环保集团公司，并将中国节能环保集团公司作为重组后的母公司。",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 1,
				num: 1,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1,
				num: 1,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "高压柜KYN28A-12", img: krcp1 },
			{ name: "高压柜KYN61", img: krcp2 },
			{ name: "高压柜NXAirS", img: krcp3 },
			{ name: "低压柜GCK", img: krcp4 },
			{ name: "低压柜GCS", img: krcp5 },
			{ name: "低压柜GFB2", img: krcp6 },
			{ name: "低压柜GGD", img: krcp7 },
			{ name: "低压柜MNS", img: krcp8 },
			{ name: "低压柜MNS2.0", img: krcp9 },
			{ name: "低压柜8PT", img: krcp10 },
			{ name: "低压柜B柜", img: krcp11 },
			{ name: "环网柜XGN74A", img: krcp12 },
			{ name: "箱变ZB", img: krcp13 },
			{ name: "箱变YB", img: krcp14 },
			{ name: "柱上断路器ZW32", img: krcp15 },
			{ name: "干式变压器SCB系列", img: krcp16 },
			{ name: "油浸式变压器S系列", img: krcp17 },
		],
		navList: [
			{
				name: "高压柜",
				isShow: false,
				id: 1,
				children: ["高压柜KYN28A-12", "高压柜KYN61", "高压柜NXAirS"],
			},
			{
				name: "低压柜",
				isShow: false,
				id: 2,
				children: [
					"低压柜GCK",
					"低压柜GCS",
					"低压柜GFB2",
					"低压柜GGD",
					"低压柜MNS",
					"低压柜MNS2.0",
					"低压柜8PT",
					"低压柜B柜",
				],
			},
			{
				name: "环网柜",
				isShow: false,
				id: 3,
				children: ["环网柜XGN74A"],
			},
			{
				name: "箱变",
				isShow: false,
				id: 4,
				children: ["箱变ZB", "箱变YB"],
			},
			{
				name: "断路器",
				isShow: false,
				id: 5,
				children: ["柱上断路器ZW32"],
			},
			{
				name: "变压器",
				isShow: false,
				id: 6,
				children: ["干式变压器SCB系列", "油浸式变压器S系列"],
			},
		],
	},
    productDetailsData:	{
		"高压柜KYN28A-12": {
			name: "高压柜KYN28A-12",
			img: krxq1,
			modelNumber: [
				{
					title: "暂无",
					img: krxq1,
				},
			],
			price: "--",
			detailImgs: [krxq1],
			modelNumberText: "KYN28A-12",
			brand: "北京科锐",
			describe:
				"KYN28A-12型开关设备由柜体和中置式可移开部件（手车）两大部分组成。根据柜内电气设备的功能，可将柜体分为五个不同的功能单元，即断路器室、母线室、电缆室、仪表室、泄压装置。各小室间和断路器室门打开时防护等级为IP2X，外壳防护等级为IP4X。断路器室、电缆室的门上均设有观察窗，能方便地观察柜内相关设备的运行状况，观察窗采用机械强度高的透明材料制成，满足内部燃弧试验要求。",
			report: [krbg1, krbg2, krbg3],
		},
		高压柜KYN61: {
			name: "高压柜KYN61",
			img: krxq2,
			modelNumber: [
				{
					title: "暂无",
					img: krxq2,
				},
			],
			price: "--",
			detailImgs: [krxq2],
			modelNumberText: "KYN61",
			brand: "北京科锐",
			describe:
				"KYN28A-12型开关设备由柜体和中置式可移开部件（手车）两大部分组成。根据柜内电气设备的功能，可将柜体分为五个不同的功能单元，即断路器室、母线室、电缆室、仪表室、泄压装置。各小室间和断路器室门打开时防护等级为IP2X，外壳防护等级为IP4X。断路器室、电缆室的门上均设有观察窗，能方便地观察柜内相关设备的运行状况，观察窗采用机械强度高的透明材料制成，满足内部燃弧试验要求。",
			report: [krbg4, krbg5, krbg6, krbg7],
		},
		高压柜NXAirS: {
			name: "高压柜NXAirS",
			img: krxq3,
			modelNumber: [
				{
					title: "暂无",
					img: krxq3,
				},
			],
			price: "--",
			detailImgs: [krxq3],
			modelNumberText: "KYN61",
			brand: "北京科锐",
			describe:
				"KYN61-40.5型户内金属铠装移开式开关设备（以下简称KYN61开关柜），它适用于40.5kV三相交流的单母线或单母线分段的电力系统，作为接受和分配电能的成套开关设备，可广泛应用于发电厂、变电站、工矿企业、以及电业系统的变电所的变电、输电等场合，实现对电气设施的监测、控制和保护。具有防止带负荷推拉断路器手车、防止误分合断路器、防止接地开关处在闭合位置时关合断路器、防止误入带电间隔、防止带电时误合接地开关的联锁功能。设备性能稳定、结构合理、使用方便、安全可靠。",
			report: [krbg8, krbg9, krbg10, krbg11],
		},
		低压柜GCK: {
			name: "低压柜GCK",
			img: krxq4,
			modelNumber: [
				{
					title: "暂无",
					img: krxq4,
				},
			],
			price: "--",
			detailImgs: [krxq4],
			modelNumberText: "GCK",
			brand: "北京科锐",
			describe: `GCK 低压抽出式开关柜适用于交流50Hz，额定工作电压380V~660V 的低压配电系统中，作为受电、馈电、母联、照明、电动机控制及功率
                补偿之用，它包含动力中心（PC）和电动机控制中心（MCC）之功能，满足工矿企业、高层宾馆、机场、医院等供配电及动力控制之用。
                特点：
                开关柜的结构通用性强，组装灵活，能满足各种结构形式和防护等级要求。重量轻，强度大 ，并具有优越的散热性。外表采用环氧粉沫涂料静电喷涂，附着力强，耐磨性好，美观大方；
                相同规格的功能单元均能互换，一旦发生事故，即可将事故单元抽出而更换备用单元，大大缩短了故障时间，提高了设备的可靠性；
                框架的所有结构部件均以螺钉紧固连接而成，避免了焊接变形和应力，提高了精度，且具有较大的机械强度，完全满足该开关柜的各种性能要求和变化；
                在MCC 方案中，开关柜内部分成三个区域（室），母线区、电器设备区和电缆区，且三个区域用钢板隔开，保证线路的正常运行，当抽屉抽出柜时，柜内带电体均不外露，安全可靠；
                在PC 方案中，每柜安装1-3 台断路器，断路器具有工作位置、试验位置和断开位置，控制回路仪表，指示灯和控制按钮安装在门上，断路器手动机构凸出门外，操作时无需开启门板，安全方便；
                在固定方案中，既保留了固定方案的简洁、实用、价廉等特点，同时又具有抽屉柜同样的外观造型，其内部也分母线区、电器设备区和电缆区，三个区域也均用钢板隔开或绝缘板隔开安全、可靠，是替代国内固定式老产品的理想设备；
                在不降低外壳防护等级的情况下开关柜上顶设有自然通风网盖。`,
			report: [krbg12, krbg13, krbg14, krbg15],
		},
		低压柜GCS: {
			name: "低压柜GCS",
			img: krxq5,
			modelNumber: [
				{
					title: "暂无",
					img: krxq5,
				},
			],
			price: "--",
			detailImgs: [krxq5],
			modelNumberText: "GCS",
			brand: "北京科锐",
			describe: `GCS 低压抽出式开关柜适用于交流50Hz，额定工作电压400V~690V 的低压配电系统中，作为受电、馈电、母联、照明、电动机控制及功率补偿之用，它包含动力中心（PC）和电动机控制中心（MCC）之功能，满足工矿企业、高层宾馆、机场、医院等供配电及动力控制之用。
            特点：
            开关柜的结构通用性强，组装灵活，能满足各种结构形式和防护等级要求。重量轻，强度大 ，并具有优越的散热性。外表采用环氧粉沫涂料静电喷涂，附着力强，耐磨性好，美观大方；
            相同规格的功能单元均能互换，一旦发生事故，即可将事故单元抽出而更换备用单元，大大缩短了故障时间，提高了设备的可靠性；
            框架的所有结构部件均以螺钉紧固连接而成，避免了焊接变形和应力，提高了精度，且具有较大的机械强度，完全满足该开关柜的各种性能要求和变化；
            在MCC 方案中，开关柜内部分成三个区域（室），母线区、电器设备区和电缆区，且三个区域用钢板隔开，保证线路的正常运行，当抽屉抽出柜时，柜内带电体均不外露，安全可靠；
            在PC 方案中，每柜安装1-3 台断路器，断路器具有工作位置、试验位置和断开位置，控制回路仪表，指示灯和控制按钮安装在门上，断路器手动机构凸出门外，操作时无需开启门板，安全方便；
            在固定方案中，既保留了固定方案的简洁、实用、价廉等特点，同时又具有抽屉柜同样的外观造型，其内部也分母线区、电器设备区和电缆区，三个区域也均用钢板隔开或绝缘板隔开安全、可靠，是替代国内固定式老产品的理想设备；
            在不降低外壳防护等级的情况下开关柜上顶设有自然通风网盖。`,
			report: [krbg16, krbg17, krbg18, krbg19],
		},
		低压柜GFB2: {
			name: "低压柜GFB2",
			img: krxq6,
			modelNumber: [
				{
					title: "暂无",
					img: krxq6,
				},
			],
			price: "--",
			detailImgs: [krxq6],
			modelNumberText: "GFB2",
			brand: "北京科锐",
			describe: `GFB2-2008全封闭式开关柜是根据电力系统、设计部门和用户要求，为电力公司低压配电系统设计开发的新型低压配电产品。消化吸收了国内外同类产品的优点，引入了国外先进产品的设计理念，采用大量的先进加工设备和工艺真正实现了柜体的全封闭以及元器件之间的分隔。与传统柜型相比，具有更高的安全性和供电可靠性，该产品适用于额定频率50Hz，额定工作电压400V,额定工作电流至2500A及以下的三相四线制及三相五线制的配电系统作为动力照明及配电设备的电能转换、分配和控制之用。本装置适用于发电厂、 变电所、 石油化工、 冶金、 工矿企业、 高层建筑等低压配电系统的动力配配电、 电容补偿等电能转换。
            特点：
            柜体结构采用固定分隔式，柜内用挡板或隔板进行分隔，分隔成独立的母线室、断路器室、电缆室、二次仪表室及电缆出线小室。柜体框架采用型材设计，外壳及门板材料应采用冷轧钢板，表面喷塑； 
            每一断路器均有独立的断路器室；馈线柜两个出线断路器分左右两列布置；断路器操作手柄中心距地不大于 1.5m；
            馈线电缆设有独立的接线室；馈线柜电缆室前开门，两条电缆接线均为柜体前。柜底用钢板封护；设有与一次设备相独立的二次仪表室，可安装二次设备。开关柜上方布置有专用通讯隔室；馈线柜设有两路馈线开关共用的仪表室；`,
			report: [krbg20, krbg21, krbg22, krbg23],
		},
		低压柜GGD: {
			name: "低压柜GGD",
			img: krxq7,
			modelNumber: [
				{
					title: "暂无",
					img: krxq7,
				},
			],
			price: "--",
			detailImgs: [krxq7],
			modelNumberText: "GGD",
			brand: "北京科锐",
			describe: `GGD 型交流低压配电柜是广大电力用户及设计部门的要求，本着安全、经济、合理、可靠的原则设计的新型低压配电柜。产品具有分断能力高、动热稳定性好、电气方案灵活、组合方便、系列性、实用性强、结构新颖、防护等级高等特点。可作为低压成套开关设备的更新换代产品使用。
            特点：
            GGD交流配电柜的柜体采用通用柜形式，构架采用8MF冷弯型钢局部焊接组装而成。构架零件及专用配套零件由型钢定点生产厂家配套，
            以保证柜体的精度的质量。通用柜的零部件按模块原理设计，并有20 模的安装孔，通用系数高；
            柜体设计时充分考虑到柜体运行中的散热问题。在柜体上下两端均有不同数量的散热槽孔，当柜内电器元件发热后，热量提升，通过
            上端槽孔排出，而冷风不断地由下端的槽孔补充进柜，使密封的柜体自下而上形成一个自然通风道，达到散热的目的；
            柜体按照现代工业产品造型设计的要求，采用黄金分割比的方法设计柜体外形和各部分的分割尺寸。柜门用转轴式活动铰链与柜架相连，
            安装、拆卸方便。门的折边均嵌有一根山型橡塑条，关门时门与柜架之间的嵌条有一定的压缩行程，能防止门与柜架直接碰撞，也提高了柜体的防护等级；
            柜体表面采用静电喷涂，附着力强，质感好。整柜呈亚光色调，避免了眩目效应，给使用人员创造了较舒适的视觉环境；
            柜体的顶盖在需要时可拆除，便于现场主母线的装配和调整，柜顶的四角装有吊环，用于起吊和装运；
            标准柜体的防护等级为IP30，用户也可根据使用环境的要求在IP20-IP40 之间选择。`,
			report: [krbg24, krbg25, krbg26, krbg27],
		},
		低压柜MNS: {
			name: "低压柜MNS",
			img: krcp8,
			modelNumber: [
				{
					title: "暂无",
					img: krcp8,
				},
			],
			price: "--",
			detailImgs: [krcp8],
			modelNumberText: "MNS",
			brand: "北京科锐",
			describe: `MNS型低压抽出式开关柜（以下简称装置）是ABB公司产品的国产化型号。该装置适用于发电厂、石油、化工、医院、冶金、纺织、数据中心、工矿企业、高层建筑等低压配电系统的动力配电和电动机控制中心、电容补偿的电能转换、分批与控制。
            在大单机容量的发电机、大规模石化等行业的低压动力控制中心和电动机中心等电力使用场合时能满足与计算机接口的特殊需要。`,
			report: [krbg28, krbg29, krbg30, krbg31],
		},
		"低压柜MNS2.0": {
			name: "低压柜MNS2.0",
			img: krcp9,
			modelNumber: [
				{
					title: "暂无",
					img: krcp9,
				},
			],
			price: "--",
			detailImgs: [krcp9],
			modelNumberText: "MNS2.0",
			brand: "北京科锐",
			describe: `MNS2.0型低压开关柜，是由ABB公司授权制造的成套开关设备。MNS2.0型成套开关设备由低压配电柜（或称动力中心PC）、马达控制中心（MCC）、电容补偿柜等组成，可采用合资或国产优质品牌的电器元件。适用于交流50（60）Hz，额定电压380（400）V的控制、配电系统，适用于电厂、电站、工矿企业等电力用户，作为动力配电、电动机控制、无功电容补偿及照明等配电设备的电能转换、分配和控制之用。这种柜型具有独特的免维护绝缘转接结构。该产品的主要电气元件均采用ABB公司系列产品，作为ABB公司中国合作伙伴，其质量能够得到可靠保障。`,
			report: [krbg32, krbg33, krbg34, krbg35, krbg36],
		},
		低压柜8PT: {
			name: "低压柜8PT",
			img: krcp10,
			modelNumber: [
				{
					title: "暂无",
					img: krcp10,
				},
			],
			price: "--",
			detailImgs: [krcp10],
			modelNumberText: "8PT",
			brand: "北京科锐",
			describe: `SIVACON 8PT是一种由西门子公司新型的低压开关柜，它具有断路器技术、固定安装式技术、抽出式技术及插入式技术设计。8PT可应用在最大额定电流至7400A 各种容量等级的层面上。各种模块可灵活组合，以满足各种不同的要求。柜内采用优质的西门子元器件，以保证设备长期可靠运行。`,
			report: [krbg37, krbg38, krbg39, krbg40, krbg41],
		},
		低压柜B柜: {
			name: "低压柜B柜",
			img: krcp11,
			modelNumber: [
				{
					title: "暂无",
					img: krcp11,
				},
			],
			price: "--",
			detailImgs: [krcp11],
			modelNumberText: "B柜",
			brand: "北京科锐",
			describe: `SIVACON 8PT是一种由西门子公司新型的低压开关柜，它具有断路器技术、固定安装式技术、抽出式技术及插入式技术设计。8PT可应用在最大额定电流至7400A 各种容量等级的层面上。各种模块可灵活组合，以满足各种不同的要求。柜内采用优质的西门子元器件，以保证设备长期可靠运行。`,
			report: [krbg42, krbg43, krbg44],
		},
	},
    contactListData: {
		list: [
			{
				name: "李欣",
				position: "大客户部总经理（全国）",
				id: "2",
				phoneNum: "13810063422",
				color: "#23B095 ",
				email: "5489024@qq.com",
			},
			{
				name: "王亚楠",
				position: "大客户销售经理（全国）",
				id: "2",
				phoneNum: "13811303842",
				color: "#23B095 ",
				email: "13522910862@163.com",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "2019年中国北京世界园艺博览会园区基础建设项目",
				id: 1,
				price: "11981530.4",
				time: "2019",
				site: "北京市",
				type: "基础建设",
				unit: "北京市政路桥股份有限公司",
				desc: "2019年中国北京世界园艺博览会是经国际园艺生产者协会批准、国际展览局认可，由中国政府主办、北京市承办的最高级别的世界园艺博览会，我公司中标此项目电力工程设备供货，包含环网柜、变压器、高低压柜，中标额为11981530.4元，项目进展顺利，设备运行良好，得到业主单位好评",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb1 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht1 },
					{ title: "", path: krht2 },
				],
				product: "环网柜、变压器、高低压柜",
			},
			{
				name: "海创百纳高端仪器生产园项目（怀柔科学城硬科技孵化项目）永久用电安装工程",
				id: 2,
				price: "332480",
				time: "2021",
				site: "北京市",
				type: "基础建设",
				unit: "北京顺通晟达科技有限公司",
				desc: "怀柔科学城硬科技孵化项目位于北京市怀柔区，本次主要供货干式变压器，项目金额332480元，项目进展顺利，设备运行良好，得到业主单位好评",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb2 }],
				// 合作证明图
				contractList: [{ title: "", path: krht3 }],
				product: "干式变压器",
			},
			{
				name: "敦煌首航节能100MW太阳能熔盐塔式光热发电示范项目",
				id: 3,
				price: "12195192.03",
				time: "2018",
				site: "甘肃省",
				type: "基础建设",
				unit: "敦煌首航节能新能源有限公司",
				desc: "首航节能敦煌100MW熔盐塔式光热发电项目是首批国家太阳能热发电示范项目。该电站由首航自主设计、投资和建设。2018年12月底并网发电，成为中国首个百兆级国家太阳能热发电示范电站，也是目前全球最高、聚光面积最大的熔盐塔式光热电站。本次主要供货配电箱、控制箱等产品，项目金额12195192",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb3 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht4 },
					{ title: "", path: krht5 },
				],
				product: "配电箱",
			},
			{
				name: "首都机场公共区“油改电”工程配套电力改造工程项目",
				id: 4,
				price: "5007134.8",
				time: "2020",
				site: "北京市",
				type: "基础建设",
				unit: "北京浮士德电力工程有限公司",
				desc: "本项目中标产品为箱式变电站，中标金额为5007134.8元，项目进展顺利，设备运行良好，得到业主单位好评",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb4 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht6 },
					{ title: "", path: krht7 },
				],
				product: "欧式箱变",
			},
			{
				name: "2021年丽水缙云70MWp农光互补光伏发电一次调频项目",
				id: 5,
				price: "--",
				time: "2021",
				site: "丽水缙云",
				type: "储能系统一次调频",
				unit: "中国电建",
				desc: `1)	项目名称：浙江丽水缙云壶镇70MWP农光互补一次调频3.78MW/2.2KWH储能系统项目 
                2)	工程容量：工程位于浙江省缙云县壶镇镇，光伏直流侧装机规模为70MWp。折合交流侧功率为62MW，按照6%的储能调节容量来计算，应配置不低于62*0.06=3.72MW的储能功率，本项目实际配置总容量为3.78MW/2.2MWh。
                3)	工程地址：浙江省丽水市缙云县壶镇八桥村 
                4)	工程情况：本工程新建110kV升压站1座，电站本期通过3回35kV集电线路接入浙江丽水缙云壶镇70MW农光互补光伏升压站35kV母线；新上3.78MW/2.2MWh储能，通过35kV线路1回接入光伏升压站35kV母线；110 kV升压站最终出线l回接至里隆变110kV线路。 `,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb5 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht8 },
					{ title: "", path: krht9 },
				],
				product: "储能电池舱、升压变流一体仓",
			},
			{
				name: "2022年江西分宜海螺水泥2MW/4.4MWh",
				id: 6,
				price: "--",
				time: "2022",
				site: "江西分宜",
				type: "储能电站",
				unit: "海螺新能源",
				desc: `本项目位于江西省市分宜县分宜海螺水泥公司厂区内。拟利用厂区空地建设储能电站，装机容量为2MW/4.4MWh，全部采用集装箱式安装，储能并网柜接入光伏项目一次侧。 `,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb6 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht10 },
					{ title: "", path: krht11 },
				],
				product: "储能电池舱及能量管理平台",
			},
			{
				name: "2021年武汉电院V2G光伏车棚直流微网",
				id: 7,
				price: "--",
				time: "2021",
				site: "武汉电院",
				type: "直流微网",
				unit: "武汉电院",
				desc: `    近年来，各大高校吹起“节能”风，开发新能源建设“绿色校园”成为新趋势。2021年10月12日，杭州平旦科技参与的由校园场景的“光储充放“项目正式投运，该项目落地于武汉电力职业技术学院，由国网湖北综合能源服务有限公司投资，助力高校及社会实现综合能源建设！该项目利用武汉电力职业技术学院现有场地资源，建设”光储充放“一体化场站，站内配置（250kW/202kWh）储能设备，（20kWp）光伏车棚及（240kW容量）V2G设备。通过平旦科技一体站能源管理系统，实现光伏发电、储能、V2G(Vehicle-to-grid)能源智能调用，满足校园削峰填谷、教学应用等需求。 `,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb7 }],
				// 合作证明图
				contractList: [],
				product: "储能电池舱及能量管理平台",
			},

			{
				name: "2022年30MW/30MWh玉环电场火电联储调频",
				id: 8,
				price: "--",
				time: "2022",
				site: "浙江温州玉环",
				type: "火电联储调频",
				unit: "华能玉环电厂",
				desc: ` 华能首个百万千瓦机组储能调频项目，用于提升火电厂AGC二次调频性能，提升电力系统的电能质量和安全稳定性，从而获得电力市场收益。接入电厂3、4号机组6kV厂用电系统，辅助机组AGC调频。集继电保护、控制、SOE、消防、故障录波为一体，更是填补了国内储能系统空白。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb8 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht12 },
					{ title: "", path: krht13 },
				],
				product: "火电联储能量管理平台",
			},
			{
				name: "国网江苏南京变电110kV团结变10kVSVG项目",
				id: 9,
				price: "4379999.78",
				time: "2020",
				site: "江苏省南京市",
				type: "110kV变电站",
				unit: "国网江苏省电力有限公司南京供电分公司",
				desc: ` 2020年国网物资招标由我司中标，国网江苏省电力有限公司南京供电分公司计划在团结变10kV母线上装设1套补偿容量为6Mvar的动态无功补偿成套装置（SVG型），可实现无功从感性6Mvar~容性6Mvar范围内连续快速调节。设计单位： 南京国联电力工程设计有限公司，中标金额为4379999.78元`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb9 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht14 },
					{ title: "", path: krht15 },
				],
				product: "SVG",
			},
			{
				name: "杭州至海宁城际铁路工程",
				id: 10,
				price: "2671133",
				time: "2019",
				site: "浙江省杭州市",
				type: "SVG动态无功补偿装置",
				unit: "浙江高速物流有限公司",
				desc: ` 杭州至海宁城际铁路工程经浙江省发改委同意建设，并列为浙江省重点建设项目，2018年12月我司中标SVG动态无功补偿装置，中标金额2671133元，2021年6月整个项目通过竣工验收，进入出去运营。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb10 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht16 },
					{ title: "", path: krht17 },
				],
				product: "SVG",
			},
			{
				name: "查务500千伏变电站新建工程",
				id: 11,
				price: "1199000.01",
				time: "2019",
				site: "西藏自治区日喀则市",
				type: "静态补偿装置,AC10kV,户外",
				unit: "国网西藏电力有限公司",
				desc: ` 2019年为国家整体发展战略和边防安全提供电力保障；扩大西藏电网覆盖范围，并兼顾西藏电网和尼泊尔电网联网需要，促进节能减排，故新建查务500kV变电站，我司中标SVC装置，中标金额1199000.01元，2021年9月整个项目通过竣工验收`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb11 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht18 },
					{ title: "", path: krht19 },
				],
				product: "SVG",
			},
			{
				name: "和墨洛城乡客运公交一体化充电基础设施建设项目施工总承包采购项目",
				id: 12,
				price: "747834",
				time: "2022",
				site: "新疆维吾尔自治区和田地区",
				type: "120kW一体式一机双枪直流充电机",
				unit: "国网新疆综合能源服务有限公司",
				desc: ` 项目建设地点位于墨玉县南扎瓦客运站、洛浦县客运站、和田市西郊客运站，停车场结合新能源公交车运行情况和充电周期建设相对应充电桩、充电桩钢结构雨棚（广告牌）及相对应充电桩配电设施（附属照明、监控、设施），满足停靠的新能源公交车充电；同时钢结构雨棚屋面配置分布式光伏发电（储能设备），通过新疆错峰电价优势，进行夜间储能，日间供能，以达到绿色节约和光-储-充一体化充电站示范目的。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: krlb12 }],
				// 合作证明图
				contractList: [
					{ title: "", path: krht20 },
					{ title: "", path: krht21 },
				],
				product: "充电桩",
			},
		],
	},
    evaluationData:{
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [],
	},
    successfulBidderData: {
		info: [
			{
				name1: "05-10kV柱上变压器台成套设备",
				name2: "国网青海省电力公司2022年第二次（282208）协议库存物资招标采购项目",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "【JT0322JMDX001-655】10kV仁和线坑仔支线#7塔7T1开关等18台自动化终端、【JT0322JMDX001-800】10kV中富线#8塔8T6开关等2台自动化终端",
				name2: "【JT0322JMDX001-655】10kV仁和线坑仔支线#7塔7T1开关等18台自动化终端、【JT0322JMDX001-800】10kV中富线#8塔8T6开关等2台自动化终端",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "淮北矿业股份有限公司淮北矿业2022年芦岭煤矿南风井高压开关柜及配件招标（公开）",
				name2: "淮北矿业股份有限公司淮北矿业2022年芦岭煤矿南风井高压开关柜及配件招标项目",
				name3: "物资采购",
				date: "2022/12/6",
			},
			{
				name1: "恩平供电局平富岗10kV城北线自动化改造工程-高压计量柜",
				name2: "恩平供电局平富岗10kV城北线自动化改造工程- 高压计量柜",
				name3: "物资采购",
				date: "2022/12/2",
			},
			{
				name1: "A01：箱式变压器",
				name2: "北京局集团公司2022年北京供电段电力增容改造（第一批、第二批）用箱式变压器招标采购",
				name3: "物资采购",
				date: "2022/12/1",
			},
			{
				name1: "【JT0322JMDX001-655】江门蓬江局110kV堡棠站10kV仁和线坑仔支线#7塔7T1开关等18台自动化终端系统设备日常维修工程（真空开关箱维修材料）",
				name2: "【JT0322JMDX001-655】江门蓬江局110kV堡棠站10kV仁和线坑仔支线#7塔7T1开关等18台自动化终端系统设备日常维修工程（真空开关箱维修材料）",
				name3: "物资采购",
				date: "2022/12/1",
			},
			{
				name1: "2022-2023年配网自动化维护施工项目福田局北京科锐控制器及永磁驱动采购",
				name2: "2022-2023年配网自动化维护施工项目福田局北京科锐控制器及永磁驱动采购",
				name3: "物资采购",
				date: "--",
			},
			{
				"企业名称": "北京科锐配电自动化股份有限公司",
				"name1": "丽江隆基项目-肘型电缆头（北京科锐配电自动化）",
				"name4": "陕西建工安装集团有限公司",
				"name2": "丽江隆基5GW单晶硅棒、硅片项目工程",
				"name3": "物资采购",
				"date": "2017年11月26日",
				"out": true
			}
		],
	},
    lawData: 	{
		info: [],
	},
    tipData:	{
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
}